import { render, staticRenderFns } from "./PageHeading.vue?vue&type=template&id=e0c87f56&scoped=true&"
import script from "./PageHeading.vue?vue&type=script&lang=js&"
export * from "./PageHeading.vue?vue&type=script&lang=js&"
import style0 from "./PageHeading.vue?vue&type=style&index=0&id=e0c87f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c87f56",
  null
  
)

export default component.exports